import { render } from "./MaoVideoPlayer.vue?vue&type=template&id=5f125708&scoped=true"
import script from "./MaoVideoPlayer.vue?vue&type=script&lang=js"
export * from "./MaoVideoPlayer.vue?vue&type=script&lang=js"

import "./MaoVideoPlayer.vue?vue&type=style&index=0&id=5f125708&scoped=true&lang=scss"
import "./MaoVideoPlayer.vue?vue&type=style&index=1&id=5f125708&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f125708"]])

export default __exports__